import {DetailsList, FontSizes, FontWeights, IconButton, SelectionMode, Stack} from "@fluentui/react";
import AuthContext from "../Services/AuthContext";
import * as React from "react";
import {useContext} from "react";
import {useParams} from "react-router-dom";
import {MoneyField} from "../Utilities/MoneyField";

function PaymentScheduleList(props) {
    const [user] = useContext(AuthContext);
    const params = useParams();
    const columns = [
        {
            key: 'value',
            name: 'Wartość',
            ariaLabel: 'Wartość transzy',
            fieldName: 'value',
            minWidth: 160,
            isRowHeader: true,
            isResizable: false,
            ...MoneyField()
        },
        {
            key: 'due',
            name: 'Termin',
            ariaLabel: 'Termin Transzy',
            fieldName: 'due',
            minWidth: 120,
            isRowHeader: true,
            isResizable: true,
        },
        {
            key: 'delete',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'delete',
            minWidth: 80,
            isRowHeader: true,
            isResizable: true,
            onRender: (item) => (<IconButton iconProps={ {iconName: 'trash' }} title='Usuń' onClick={() => _delete(item.id)}/>)
        }
    ];

    const _delete = (id) => {
        fetch(`/api/payment/schedule/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.refresh(); })
            .catch(err => { console.log(err) })
    }
    if (props.data.length) {
        return (<Stack.Item>
            <h2 style={{fontSize: FontSizes.size24, fontWeight: FontWeights.light}}>
                {props.title}
                <a href={`/api/report/project/${params.id}/payment/schedule?auth=${user.token}`} target={'_blank'} rel="noreferrer">
                    <IconButton iconProps={{iconName: 'PDF'}} title='PDF'/></a>
            </h2>
            <DetailsList items={props.data} columns={columns} selectionMode={SelectionMode.none}/>
        </Stack.Item>);
    }
    return null;
}

PaymentScheduleList.defaultProps = {
    title: 'Harmonogram Wpłat'
}

export default PaymentScheduleList;